<template>
  <div>
    <v-layout v-if="type !== 'TEXT'">
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap justify-center>
                <v-flex xs12 sm6 md3>
                  <text-input
                    :form="form"
                    label="Texto"
                    :v-errors="errors"
                    :value.sync="form.text"
                    name="text"
                    v-validate="'required'"
                  ></text-input>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <text-input
                    :form="form"
                    label="Valor"
                    :v-errors="errors"
                    :value.sync="form.value"
                    name="value"
                    v-validate="'required'"
                  ></text-input>
                </v-flex>

                <v-flex xs12 sm3 md1>
                  <check-input
                    :form="form"
                    label="Activo"
                    :v-errors="errors"
                    :value.sync="form.status"
                    name="status"
                    v-validate="'required'"
                  ></check-input>
                </v-flex>
                <v-flex xs12 sm3 md1>
                  <v-btn v-if="!editing" color="primary" @click="saveOption">Guardar</v-btn>
                  <v-btn v-else color="secondary" @click="updateOption">Actualizar</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
                <div v-if="type === 'TEXT'">
                  <v-textarea outline
                    label="Respuesta"
                    name="name"
                    :disabled="true"
                  ></v-textarea>
                </div>
                <div v-if="type === 'ONLY_OPTION' || type === 'MULTIPLE_OPTION'">
                  <v-layout wrap justify-space-between
                    v-for="(option, i) in options"
                    :key="i"
                  >
                    <v-flex xs9>
                      <v-checkbox v-if="type === 'MULTIPLE_OPTION'" :off-icon="option.status == 1 ? 'check_box' : 'check_box_outline_blank'" :disabled="true" :label="`${option.text}, Val: ${option.value}`" ></v-checkbox>
                      <v-radio v-if="type === 'ONLY_OPTION'" :off-icon="option.status == 1 ? 'radio_button_checked' : 'radio_button_unchecked'" :disabled="true" :label="`${option.text}, Val: ${option.value}`" ></v-radio>
                    </v-flex>
                    <v-flex xs2>
                      <v-tooltip top>
                        <v-icon
                          medium
                          class="mr-2"
                          @click.prevent="editOption(option)"
                          slot="activator"
                        >
                          edit
                        </v-icon>
                        <span>Editar</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <v-icon
                          medium
                          class="mr-2"
                          @click.prevent="deleteOption(option.id)"
                          slot="activator"
                        >
                          delete
                        </v-icon>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </div>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import Form from 'vform'
  import axios from 'axios'

  export default {
    name: 'survey-question-option-view',
    props: {
      surveyId: {
        type: Number,
        default: 0,
      },
      questionId: {
        type: Number,
        default: 0,
      },
      options: {
        type: Array,
        default: []
      },
      type: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        form: new Form({
          survey_id: '',
          survey_question_id: '',
          text: '',
          value: '',
          status: true,
        }),
        editing: false,
      }
    },
    watch: {
      surveyId(newValue, oldValue) {
        this.form.survey_id = newValue
      },
      questionId(newValue, oldValue) {
        this.form.survey_question_id = newValue
      },
    },
    created () {
      this.form.survey_id = this.surveyId
      this.form.survey_question_id = this.questionId
    },
    methods: {
      async saveOption() {
        if (await this.formHasErrors()) return

        const { status } = await this.form.post('/api/survey/question/option')

        if (status === 200) {
          this.$emit('updateData')
          this.clearForm()
        }
      },
      editOption(option) {
        this.editing = true
        this.form = new Form({
          id: option.id,
          survey_id: this.surveyId,
          survey_question_id: this.questionId,
          text: option.text,
          value: option.value,
          status: option.status == 1,
        })
      },
      async updateOption() {
        if (await this.formHasErrors()) return

        const { status } = await this.form.put('/api/survey/question/option')

        if (status === 200) {
          this.$emit('updateData')
          this.clearForm()
        }
      },
      deleteOption(id) {
        axios.delete(`/api/survey/question/option/${id}`)
          .then(response => {
            if (response.status === 200) {
              this.$emit('updateData');
            }
          })
      },
      clearForm() {
        this.editing = false
        this.form = new Form({
          survey_id: this.surveyId,
          survey_question_id: this.questionId,
          text: '',
          value: '',
          status: true,
        })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/surveys/survey_question_options.vue